export function bodyFetch(
  url,
  sendData,
  processFn,
  method = "POST"
) {
  let myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  let parsedJson;
  try {
    parsedJson = JSON.stringify(sendData);
  } catch (exception) {
    console.error(exception);
    parsedJson = null;
  }

  let requestOptions = {
    method: method,
    headers: myHeaders,
    body: parsedJson,
  };

  fetch(url, requestOptions)
    .then((response) => response.json())
    .then(processFn)
    .catch((error) => {
      console.error(error);
    });
}